import { useRouter } from './../../../../router/use-router/index';
import { debounce } from 'lodash';
import i18n from './../../../../i18n';
import { TAX_SA_BANNER_TEMP, TAX_NOTIFY_ADD_BILLING, GuideStatus, DimensionType } from './../../../../const/notification';
import { updateGuideStatus } from './../../../../service/index';
import { trackEvent } from './../../../../tea-tracker';
import { sessionStorageSetItem } from './../../../../utils/localStorage';

export default function useNotification() {
	const router = useRouter();
	const ROOT_ELEMENT = document.documentElement;
	const FONT_FAMILY = getComputedStyle(ROOT_ELEMENT).getPropertyValue('--ttam-font-family-default');

  function handleRedirect(current_notification: {[key: string]: any}) {
    const redirect = current_notification?.redirect ?? ''
    if(redirect) {
      router.push({
        name: redirect
      })
    }
  }

  function getProperTranslation(notification: {[key: string]: any}, currency?: string) {
    if(notification.msgType === 3) {
      const { starlingKey, extra: extraData } = notification.i18n;
      return i18n.t(starlingKey, {cost: extraData[notification.keys[0]], currency: currency});
    } else {
      return i18n.t(notification.i18n);
    }
  }

	function handleMoreBtnVisible(notification, _showMoreRefObject: {[key: string]: boolean }): void {
		const canvas = document.createElement('canvas')
		const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
		ctx.font = `13px ${FONT_FAMILY}`
		const text = getProperTranslation(notification)
		const width = +ctx?.measureText(text as string)?.width
		const maxTextWidth = 316;
		if(width > maxTextWidth) {
			_showMoreRefObject.showMore = true
		}
	}

	function debounceGotoQualification(): void {
		debounce(() =>
			router.push({
				name: 'qualification',
				query: {
					formIndex: 1
				}
			}), 500)
	}

	function gotoNewBilling(): void {
		debounceGotoQualification()
	}

	function setNotifyRead(curNoti: {[key in string]: any}) {
		if (curNoti.type === TAX_SA_BANNER_TEMP) {
			updateGuideStatus({
					keys: [GuideStatus.CLOSE_ARABIC_TIPS],
					dimension: DimensionType.adv
				})
		} else if (curNoti.type === TAX_NOTIFY_ADD_BILLING) {
			trackEvent('adp_waplite_click', {
				billinginfo: 'simplified_billinginfo_banner_close',
				order: 2
			})
		}
	}

	function closeNotification(aadvid: any, curNoti: {[key in string]: any}, isAbExperimentGroup, index: number): void {
		trackEvent('banner_dismiss', {
			suggestion_type: curNoti.id,
			user_type: 1,
			entity_type: 1,
			entity_id: aadvid,
			scene: 101,
			page: 'dashboard'
		})
		setNotifyRead(curNoti)
		const key = isAbExperimentGroup ? `noti-advId-${aadvid}-notiId-${curNoti?.id}-${curNoti?.priority}`
		: `noti-advId-${aadvid}-i18n-${curNoti?.i18n}-${curNoti?.priority}`;
		const timestamp = isAbExperimentGroup ? sessionStorage.getItem(key) ?? 0 : localStorage.getItem(key) ?? 0
		const expires = (+timestamp ? +timestamp : Date.now()) + 864e+5
		// A/B Test new API will use session storage
		isAbExperimentGroup ? sessionStorageSetItem(key, `${new Date(expires).getTime()}`) : localStorage.setItem(key, `${new Date(expires).getTime()}`)
	}

  return {
		handleRedirect,
		getProperTranslation,
		handleMoreBtnVisible,
		gotoNewBilling,
		closeNotification
  }
}
